import './index.css';
// src/main.tsx
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";

// Global error listeners for visible fatal banner (optional)
window.addEventListener("error", (e) => {
  const el = document.getElementById("__fatal");
  if (el) {
    el.textContent = `Global error: ${e?.error?.message || e.message || String(e)}`;
    el.style.display = "block";
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const el = document.getElementById("__fatal");
  if (el) {
    el.textContent = `Unhandled promise rejection: ${String(e.reason)}`;
    el.style.display = "block";
  }
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
